/**
 * Display labels for the history-retention dropdown.
 *
 * The *values* come from the backend's OpenAPI schema (`RetentionPeriod`), so this file cannot
 * invent a period the API would reject. What it adds is the label and the display order, which
 * are UI copy and have no business in the domain layer — the same split as `messages.ts`.
 *
 * Ported from `lib/constants/retention.ts`'s `RETENTION_PERIOD_OPTIONS`.
 */

import type { RetentionPeriod } from "@/api/queries";

export const RETENTION_PERIOD_OPTIONS: ReadonlyArray<{ key: RetentionPeriod; label: string }> = [
  { key: "1d", label: "1 day" },
  { key: "1w", label: "1 week" },
  { key: "1m", label: "1 month" },
  { key: "1q", label: "1 quarter" },
  { key: "6m", label: "6 months" },
  { key: "1y", label: "1 year" },
  // The default, and last rather than first: it is the safe state, not the recommended one.
  { key: "forever", label: "Keep forever" },
];
